import EntitlementDetails from './EntitlementDetails';

export default EntitlementDetails;
